import {
  ColumnDirective,
  ColumnsDirective,
  EditSettingsModel,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Inject,
  DetailRow,
  Page,
  PageSettingsModel,
  Resize,
  Toolbar,
  Column,
  RowSelectEventArgs,
  Group,
} from '@syncfusion/ej2-react-grids';
import React, { Component } from 'react';
import {GetBackendUrlForGlobalFunctions, GetErpTypeFromConfig} from '../../App';
import ReactDOM from 'react-dom';
import { getValue } from '@syncfusion/ej2-base';
import { getusers } from '../../services/Users/Users';
import './style.css';
import { FiChevronDown } from 'react-icons/fi';
import { BsCheck2All, BsClouds, BsThreeDots} from 'react-icons/bs';
import { FaCheck, FaTimes} from "react-icons/fa";
import { BiRefresh } from 'react-icons/bi';
import {
  ButtonPropsModel,
  DialogComponent,
} from '@syncfusion/ej2-react-popups';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import SystemLog from './SystemLog';
import { SwitchComponent } from '@syncfusion/ej2-react-buttons';
import Message from '../../utils/Message/Message';
import { FaPlay, FaStop } from 'react-icons/fa';
import { all_information, loadingShow } from '../../App';
import CompanyTable from '../Settings/Security/CampanyPortfolio/CampanyPortfolio';
import {
  EditContainer,
  EditContainerTask,
  getContainer,
  getContainerTaskAll,
  getContainerTaskOne,
} from '../../services/Dig/SyncContainer/SyncContainerServices';
import axios from 'axios';
import {
  Addsource_request,
  Deletesource_request,
  getsource_request,
} from '../../services/Dig/RequestSourceService/RequestSourceService';
import { io } from 'socket.io-client';
import { DateTimePickerComponent } from '@syncfusion/ej2-react-calendars';
import { ClickEventArgs } from '@syncfusion/ej2-react-navigations'; 
interface IProps {}
interface IState {
  CompanyData: any;
  UserAllData: any;
  UsersTempData: any;
  ContainerAllData: any;
  ContainerTempData: any;
  ChildGrid: any;
  ChildData: any;
  hideAddDialogLogMessage: any;
  logMessage: any;
  showSchedulerDialog: boolean;
}

export default class TaskTracker extends Component<IProps, IState> {
  private current_filter: string = '';
  private selectedShowLogMessageClickedItem: {
    container_task_id: number | null;
  } = {
    container_task_id: null,
  };
  private selectedSchedulerItem: any = null;
  public editOptions: EditSettingsModel = {
    allowAdding: false,
    allowDeleting: false,
    allowEditing: false,
    allowEditOnDblClick: false,
    showConfirmDialog: false,
    showDeleteConfirmDialog: false,
  };
  public shipFormat: object = { type: 'date', format: 'dd/MM/yyyy' };
  public toolbarOptions1 = ['Search'];
  public toolbarOptions = ['Search'];
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: true,
  };
  private gridCompanyTasktracker: any;
  private gridContainerTasktracker: GridComponent;

  private dateTimePickerInstance!: DateTimePickerComponent;
  private schedulerButtons: ButtonPropsModel[];
  private dialogIns: DialogComponent;
  private buttons: ButtonPropsModel[];
  private timer: any = '';
  private textareaObjLog: TextBoxComponent;
  private isMountedTT: boolean = false;
  private intervalId: NodeJS.Timeout | null = null;
  private boundFlag: boolean = true;
  private expandedRows: Array<any> = [];
  private savedExpandedIds: any[] = [];
  private isFirstLoad: boolean = true;
  private source = axios.CancelToken.source();
  private currentChildGrid: any;
  private current_row_index: number = 1;

  public showLogMessageClickedItem: { container_task_id: number | null } = {
    container_task_id: null,
  };
  private socket = io(GetBackendUrlForGlobalFunctions() as string, {
    autoConnect: false,
    transports: ['websocket'],
  });
  constructor(props: IProps) {
    super(props);
    this.textareaObjLog = new TextBoxComponent({});
    this.textareaObjLog = new TextBoxComponent({});
    this.gridContainerTasktracker = new GridComponent(props);
    this.dialogIns = new DialogComponent({});
    this.dialogIns = new DialogComponent({});
    this.state = {
      CompanyData: [],
      UserAllData: [],
      UsersTempData: [],
      ContainerAllData: [],
      ContainerTempData: [],
      ChildGrid: {},
      ChildData: [],
      hideAddDialogLogMessage: false,
      logMessage: '',
      showSchedulerDialog: false,
    };
    this.buttons = [
      {
        click: async () => {
          await this.getContainersTasks();
          Message.success('Refreshed');
          this.state.ChildData.map(
            (eachTask: { log_message: string; container_task_id: number }) => {
             /*  eachTask.last_sync_start_date = new Date() */
              if (
                eachTask.container_task_id ===
                this.selectedShowLogMessageClickedItem.container_task_id
              ) {
                this.textareaObjLog.value = eachTask.log_message;
              }
            }
          );
        },
        buttonModel: {
          content: 'Refresh',
          iconCss: 'e-icons e-refresh',

          cssClass: 'buttonrefreshforlogmessage',
        },
      },
      {
        click: () => {
          this.dialogIns.visible = false;
          this.textareaObjLog.value = '';
          this.dialogIns.visible = false;
          this.textareaObjLog.value = '';
        },
        buttonModel: {
          content: 'OK',
        },
      },
    ];
    this.schedulerButtons = [
      {
        click: async () => {
          await this.updateMaxModifiedDate();
        },
        buttonModel: {
          content: 'Yes',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ showSchedulerDialog: false });
        },
        buttonModel: {
          content: 'No',
          isPrimary: false,
        },
      },
    ];
  }

  private safeExpandRow(index: number) {
  if (index === -1) return;
  try {
    const uid = this.gridContainerTasktracker.getRowByIndex(index)?.getAttribute('data-uid') ?? '';
    const rowObj = this.gridContainerTasktracker.getRowObjectFromUID(uid);
    if (rowObj && rowObj.data) {
      this.gridContainerTasktracker.detailRowModule.expand(index);
    }
  } catch (_) {}
  }

  async updateMaxModifiedDate() {
    const targetRecord = this.selectedSchedulerItem; 
    delete targetRecord.last_sync_start_date;
    delete targetRecord.last_sync_end_date;
    const newDate = this.dateTimePickerInstance.value;

    if (!targetRecord) {
        Message.error("No task selected.");
        return;
    }

    if (!newDate) {
        Message.error("Please select a valid date.");
        return;
    }

    loadingShow(true, "Updating Date...");
    
    const updatedRecord = {
        ...targetRecord,
        max_modified_datetime: newDate
    };

    try {
        await EditContainerTask(updatedRecord);
        Message.success("Date updated successfully");
        this.setState({ showSchedulerDialog: false });
        await this.getContainersTasks();
    } catch (error: any) {
        Message.error("An error occurred while updating date.");
    } finally {
        loadingShow(false);
        this.selectedSchedulerItem = null;
    }
  }

  toolbarClickChild = (args: ClickEventArgs) => {
    if (args.item.id === 'scheduler') {
        if (this.currentChildGrid && this.currentChildGrid.getSelectedRecords().length > 0) {
            this.setState({ showSchedulerDialog: true });
        } else {
            Message.warning('Please select a record first.');
        }
    }
  };

  formatDate = (date: Date): string => {
  return `${String(date.getDate()).padStart(2, "0")}/` +
         `${String(date.getMonth() + 1).padStart(2, "0")}/` +
         `${date.getFullYear()} ` +
         `${String(date.getHours()).padStart(2, "0")}:` +
         `${String(date.getMinutes()).padStart(2, "0")}:` +
         `${String(date.getSeconds()).padStart(2, "0")}`;
  };

  formatIntervalValue(interval: string, intervalMs: bigint): string {
  switch (interval) {
    case 'Per Minute':
      return `${Math.round(Number(intervalMs) / 60000)} Minutes`;
    case 'Hourly':
      return '1 Hour';
    case 'Daily':
      return '1 Day';
    case 'Weekly':
      return '1 Week';
    case 'Once':
      return 'Run once';
    default:
      return intervalMs != null ? String(intervalMs) : '';
  }
}

  dateFormatter(dateString: string | null): string {
    if (!dateString) return '';

    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  }
  getContainer() {

    if (this.gridContainerTasktracker && !this.isFirstLoad) {
        const rows = this.gridContainerTasktracker.getRowsObject();
        this.savedExpandedIds = rows
            .filter((row: any) => row.isExpand && row.data)
            .map((row: any) => row.data.container_id);
    }

    loadingShow(true, 'Loading');
    this.boundFlag = true;
    getContainer({ org_id: all_information.company_id }, this.source)
      .then((el) => {
        loadingShow(false);
        let filteredData: Array<any> = [];
        if (this.current_filter === 'S') {
          filteredData = el.data.filter((item: any) => item.status === true);
        } else if (this.current_filter === 'E') {
          filteredData = el.data.filter((item: any) => item.status === false);
        } else {
          filteredData = el.data;
        }
        // filteredData.map((item) => {
        //   const dateFields = [
        //     'enabled_date',
        //     'next_run',
        //     'start_date',
        //     'last_run',
        //   ];

        //   dateFields.forEach((field) => {
        //     if (typeof item[field] === 'string' && item[field] !== '') {
        //       item[field] = new Date(item[field]);
        //     }
        //   });

        //   return item;
        // });
        const erpType = GetErpTypeFromConfig();
        const typeAItems = filteredData.filter(item => item.erp_type_name === erpType);
        if (this.isMountedTT) {
          // this.gridContainerTasktracker.dataSource = el.data;
          this.setState({
            ContainerTempData: typeAItems,
          }, () => {
            setTimeout(() => {
              if (this.isFirstLoad) {
                this.isFirstLoad = false;
                this.savedExpandedIds = typeAItems.map((item: any) => item.container_id);
              }
              if (this.savedExpandedIds && this.savedExpandedIds.length > 0) {
                this.savedExpandedIds.forEach((id) => {
                  const index = this.gridContainerTasktracker.getRowIndexByPrimaryKey(id);
                  this.safeExpandRow(index);
                });
              }
            }, 100);
          });
        }
      })
      .catch((err: any) => {
        loadingShow(false);
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
      });
    this.getContainersTasks();
  }
  getUsers() {
    getusers().then((res) => {
      const model = res.data.map((result: any) => {
        return {
          ...result,
          id: result.user_id,
          text: result.first_name + ' ' + result.last_name,
          company_id: result.company_id,
          color: result.status_id ? '#339933' : '#C90016',
          usersActiveText: result.status_id ? 'ACTIVE' : 'INACTIVE',
          isChecked: result.isSupport,
          isAdmin: result.isAdmin,
          isApprover: result.isAprover,
        };
      });
      if (this.isMountedTT) {
        this.setState({ UserAllData: model });
      }
    });
  }
  async getContainersTasks() {
    await getContainerTaskAll(
      { org_id: all_information.company_id },
      undefined
    ).then((res) => {
      res.data.map((item: any) => {
        item.last_sync_start_date = this.formatDate(new Date(item.last_sync_start_date));
        item.last_sync_end_date = this.formatDate(new Date(item.last_sync_end_date));
        item.max_modified_datetime = this.formatDate(new Date(item.max_modified_datetime));
      })

       const rolledStatusMap: Record<number, number> = {};
    res.data.forEach((task: any) => {
      const cid: number  = task.container_id;
      const s: number    = task.status;
      const cur          = rolledStatusMap[cid];

      if (cur === undefined)               { rolledStatusMap[cid] = s; }
      else if (s === 1)                    { rolledStatusMap[cid] = 1; }
      else if (s === 2 && cur !== 1)       { rolledStatusMap[cid] = 2; }
      else if (s === 3 && cur !== 1 && cur !== 2) { rolledStatusMap[cid] = 3; }
    });

    const updatedContainers = this.state.ContainerTempData.map((container: any) => ({
      ...container,
      container_rolled_status: rolledStatusMap[container.container_id] ?? "",
    }));

    this.setState({ ChildData: res.data, ContainerTempData: updatedContainers }, () => {
      setTimeout(() => {
        if (this.savedExpandedIds && this.savedExpandedIds.length > 0) {
          this.savedExpandedIds.forEach((id) => {
            try {
              const index = this.gridContainerTasktracker.getRowIndexByPrimaryKey(id);
              this.safeExpandRow(index);
            } catch (_) {}
          });
        }
      }, 150);
    });

    });
    
  }
  HandlerOpenScheduler(data: any) {
    this.selectedSchedulerItem = data;
    this.setState({ showSchedulerDialog: true });
  }
  private cellRenderContainerTask = (args: any) => {
    if ((args.column as Column).field === 'status') {
      const val = getValue((args.column as Column).field, args.data);
      let color = '';
      let textColor = '';
      let text = '';
      if (val === true) {
        color = '#339933';
        text = 'SUCCESS';
        textColor = 'white';
      } else if (val === false) {
        color = '#C90016';
        text = 'ERROR';
        textColor = 'white';
      }
      ReactDOM.render(
        <div
          style={{
            backgroundColor: color,
            padding: '5px',
            textAlign: 'center',
            color: textColor,
            borderRadius: '5px',
          }}
        >
          {text}
        </div>,
        args.cell as Element
      );
    }
    if ((args.column as Column).field === 'log_message') {
      const val = getValue((args.column as Column).field, args.data);
      ReactDOM.render(
        <button
          className='btn'
          style={{width: "100%", backgroundColor: "#003f72", color: "white", fontSize: "12px"}}
          onClick={() => {
            this.setState({ hideAddDialogLogMessage: true });
            this.selectedShowLogMessageClickedItem = args.data;
            this.textareaObjLog.value = val;
            this.getContainersTasks();
          }}
        >
          Show Log Message
        </button>,
        args.cell as Element
      );
    }
    if ((args.column as Column).field === 'isRun') {
      args.cell.innerHTML = '';
      let divContainer = document.createElement('div');
      divContainer.style.display = 'flex';
      divContainer.style.flexDirection = 'row';
      let spanEx = document.createElement('span');
      let buttonEx = document.createElement('button');
      let spanStop = document.createElement('span');
      let buttonStop = document.createElement('button');
      let spanRefresh = document.createElement('span');
      let buttonRefresh = document.createElement('button');

      let spanSch = document.createElement('span');
      let buttonSch = document.createElement('button');
      spanSch.classList.add('e-icons');
      spanSch.classList.add('e-timeline-today');
      spanSch.style.fontSize = '16px';
      spanSch.style.color = '#22D3EE';
      buttonSch.className = 'execute_button_task';
      buttonSch.style.marginRight = '6px';
      buttonSch.title = 'Incremental Schedule';
      buttonSch.onclick = this.HandlerOpenScheduler.bind(this, args.data); 
      buttonSch.appendChild(spanSch);

      buttonStop.className = 'execute_button_task';
      buttonStop.style.marginRight = '6px';
      buttonStop.onclick = this.HandlerCancelTask.bind(this, args.data);
      spanStop.classList.add('e-icons');
      spanStop.classList.add('e-bullet-3');
      spanStop.style.fontSize = '10px';
      spanStop.style.color = '#C90016';
      buttonStop.disabled = args.data.isDone;
      buttonStop.appendChild(spanStop);

      spanEx.classList.add('e-icons');
      spanEx.classList.add('e-play');
      spanEx.style.fontSize = '15px';
      spanEx.style.color = '#00B900';

      buttonEx.className = 'execute_button_task';
      buttonEx.style.marginRight = '5px';
      buttonEx.onclick = this.HandlerExecuteTask.bind(this, args.data, false);
      buttonEx.disabled = !args.data.isDone;
      buttonEx.appendChild(spanEx);

      spanRefresh.classList.add('e-icons');
      spanRefresh.classList.add('e-refresh');
      spanRefresh.style.fontSize = '16px';
      spanRefresh.style.color = '#00B900';
      buttonRefresh.className = 'execute_button_task';
      buttonRefresh.style.marginRight = '6px';
      buttonRefresh.onclick = this.HandlerRefreshTask.bind(this, args.data);
      buttonRefresh.appendChild(spanRefresh);
      divContainer.appendChild(buttonEx);
      divContainer.appendChild(buttonStop);
      divContainer.appendChild(buttonRefresh);
      divContainer.appendChild(buttonSch);
      args.cell.appendChild(divContainer);
    }

    if ((args.column as Column).field === 'isFull') {
      const val = getValue((args.column as Column).field, args.data);
      ReactDOM.render(
        <SwitchComponent
          checked={args.data.isFull}
          onChange={this.switchHandler.bind(this, args.data)}
        />,
        args.cell as Element
      );
    }
    if ((args.column as Column).field === 'status') {
      const val = getValue((args.column as Column).field, args.data);
      let current_content;
      if (val === 0) {
        current_content = (
          <div
            style={{
              backgroundColor: '#339933',
              width: '100%',
              height: 25,
              borderRadius: 5,
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex',
              color: 'white',
            }}
          >
            SUCCESS
          </div>
        );
      } else if (val === 1) {
        current_content = (
          <div
            style={{
              backgroundColor: '#C90016',
              width: '100%',
              height: 25,
              borderRadius: 5,
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex',
              color: 'white',
            }}
          >
            ERROR
          </div>
        );
      } else if (val === 2) {
        current_content = (
          <div
            style={{
              backgroundColor: '#dba100',
              width: '100%',
              height: 25,
              borderRadius: 5,
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex',
              color: 'white',
            }}
          >
            RUNNING
          </div>
        );
      } else if (val === 3) {
        current_content = (
          <div
            style={{
              backgroundColor: '#fcba03',
              width: '100%',
              height: 25,
              borderRadius: 5,
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex',
              color: 'black',
            }}
          >
            PENDING
          </div>
        );
      }
      ReactDOM.render(<div>{current_content}</div>, args.cell as Element);
    }
  };
  makeTaskIncremental(taskId: number) {
    const updateObj = {
        container_task_id: taskId,
        isFull: false,
    };

    EditContainerTask(updateObj).then(() => {
        this.getContainersTasks();
    });
}

  purgeLogMessage(taskId: number) {
    const updateObj = {
        container_task_id: taskId,
        log_message: '',
    };

    EditContainerTask(updateObj).then(() => {
        this.getContainersTasks();
    });
}

  async componentDidMount() {
    this.socket.on('updateTask', (args) => {
      if (this.currentChildGrid) {
        args.data.changes.map((item: string) => {
          let theValue = args.data.theData[item];
          // this.currentChildGrid.setCellValue(
          //   this.current_row_index,
          //   item,
          //   theValue
          // );
        });
        if (args.data.theData.isDone === true) {
          //this.purgeLogMessage(args.data.theData.container_task_id);
          console.log("args.data.theData.target_table: ",args.data.theData.target_table)
        if (args.data.theData.isFull === true
            && (args.data.theData.target_table != 'temp_job5mfj' && args.data.theData.target_table != 'temp_jobcacte')
            && (args.data.theData.target_table != 'TempWorkOrder' && args.data.theData.target_table != 'TempWorkOrderOperation')
        ) {
            this.makeTaskIncremental(args.data.theData.container_task_id);
        }
    }
      }
    });
    this.socket.connect();

    this.socket.on('OnDeletedOrdersFeedback', (data: any) => {
      let theData = JSON.parse(data);
      let theMessage = theData.request_sql;
      if (theMessage.includes('failed')) {
        Message.error(theMessage);
      } else {
        Message.success(theMessage);
      }
    });

    this.socket.on('OnStartTaskFeedback', (data: any) => {
      let theData = JSON.parse(data);
      let theMessage = theData.request_sql;
      if (theMessage.includes('failed')) {
        Message.error(theMessage);
      } else {
        Message.success(theMessage);
      }
    });

    this.isMountedTT = true;
    this.getContainer();
    this.getUsers();
    $('.collapse-tasktracker-icon').click(function () {
      $('.show-taskttracker-content').toggleClass('show-tasktracker');
      $('#rotate-icon-tasktracker').toggleClass('rotateIcon-tasktracker');
    });
  }
  componentDidUpdate(
    prevProps: Readonly<IProps>,
    prevState: Readonly<IState>,
    snapshot?: any
  ): void {
    if (
      prevState.hideAddDialogLogMessage !== this.state.hideAddDialogLogMessage
    ) {
      if (this.state.hideAddDialogLogMessage) {
        this.startRequestInterval();
      }
      if (!this.state.hideAddDialogLogMessage) {
        this.clearRequestInterval();
      }
    }
  }

  startRequestInterval() {
    this.clearRequestInterval();
    if (this.state.hideAddDialogLogMessage) {
      this.intervalId = setInterval(async () => {
        await this.getContainersTasks();
        this.state.ChildData.map(
          (eachTask: { log_message: string; container_task_id: number }) => {
            if (
              eachTask.container_task_id ===
              this.selectedShowLogMessageClickedItem.container_task_id
            ) {
              this.textareaObjLog.value = eachTask.log_message;
            }
          }
        );
      }, 5000);
    }
  }

  clearRequestInterval() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
  componentWillUnmount() {
    this.socket.disconnect();
    if (this.timer !== '') {
      clearInterval(this.timer);
    }
    this.isMountedTT = false;
    if (this.source) {
    }
    this.clearRequestInterval();
  }
  cellRenderContainer = (args: any) => {
    if (args.data && !args.data.hasOwnProperty('container_task_id')) {
    args.cell.style.cursor = 'pointer';
    
    args.cell.addEventListener('click', (e: any) => {
      const targetElement = e.target;
      if (targetElement.closest('button') || targetElement.closest('input')) {
        return;
      }

      const row = args.cell.closest('tr');
      const rowIndex = parseInt(row.getAttribute('data-rowindex'));
      const rowObj = this.gridContainerTasktracker.getRowObjectFromUID(
        row.getAttribute('data-uid')
      );
      
      if (rowObj?.isExpand) {
        this.gridContainerTasktracker.detailRowModule.collapse(rowIndex);
      } else {
        this.gridContainerTasktracker.detailRowModule.expand(rowIndex);
      }
    });
  }
    if ((args.column as Column).field === 'Status_Id') {
      if ((args.column as Column).field === 'Status_Id') {
        const val = getValue((args.column as Column).field, args.data);
        let color = '';
        let textColor = '';
        let text = '';
        if (val === 0) {
          color = '#339933';
          text = 'ACTIVE';
          textColor = 'white';
        } else if (val === 1) {
          color = '#C90016';
          text = 'INACTIVE';
          textColor = 'white';
        } else if (val === 2) {
          color = '#FFCA2C';
          text = 'WARNING';
          textColor = 'black';
        }
        ReactDOM.render(
          <div
            style={{
              backgroundColor: color,
              padding: '5px',
              textAlign: 'center',
              color: textColor,
              borderRadius: '5px',
            }}
          >
            {text}
          </div>,
          args.cell as Element
        );
      }
      if ((args.column as Column).field === 'enabled') {
        const val = getValue((args.column as Column).field, args.data);
        let color = '';
        let textColor = '';
        let text = '';
        if (val === true) {
          color = '#339933';
          text = 'ENABLE';
          textColor = 'white';
        } else if (val === false) {
          color = '#C90016';
          text = 'DISABLE';
          textColor = 'white';
        }
        ReactDOM.render(
          <div
            style={{
              backgroundColor: color,
              padding: '5px',
              textAlign: 'center',
              color: textColor,
              borderRadius: '5px',
            }}
          >
            {text}
          </div>,
          args.cell as Element
        );
      }
      if ((args.column as Column).field === 'log_message') {
        const val = getValue((args.column as Column).field, args.data);
        ReactDOM.render(
          <button
            className='btn btn-warning'
            onClick={() => {
              this.textareaObjLog.value = val;
              this.textareaObjLog.value = val;
              this.dialogIns.open();
            }}
          >
            Show Log Message
          </button>,
         args.cell as Element
        );
      }
    }
    if (
    (args.column as Column).field === 'container_rolled_status' &&
    args.data &&
    !args.data.hasOwnProperty('container_task_id')
  ) {
    const val: number = args.data.container_rolled_status;

    const statusConfig: Record<number, { bg: string; text: string; color: string }> = {
      0: { bg: '#339933', text: 'SUCCESS',  color: 'white' },
      1: { bg: '#C90016', text: 'ERROR',   color: 'white' },
      2: { bg: '#dba100', text: 'RUNNING',  color: 'white' },
      3: { bg: '#fcba03', text: 'PENDING',  color: 'black' },
    };

    const cfg = statusConfig[val];
    if (cfg) {
      ReactDOM.render(
        <div
          style={{
            backgroundColor: cfg.bg,
            padding: '3px',
            textAlign: 'center',
            color: cfg.color,
            borderRadius: '5px',
          }}
        >
          {cfg.text}
        </div>,
        args.cell as Element
      );
    }
  }
  };
  public rowselect(args: RowSelectEventArgs): void {
    let selRecord: any = args.data;
    let dataUsers: any = [];
    // let dataContainer:any=[];
    const companyId = selRecord.id;
    const adaptorId = selRecord.adaptor_id;
    const containerDatas = this.gridContainerTasktracker.dataSource as any;
    const dataContainer = containerDatas.filter(
      (item: any) => item.adapter_id === adaptorId
    );
    this.state.UserAllData.map((item: any) => {
      if (item.company_id === companyId && item.isSupport === true) {
        dataUsers.push(item);
      }
    });
    (this.gridContainerTasktracker as GridComponent).dataSource = dataContainer;
    this.setState({
      UsersTempData: dataUsers,
      ContainerTempData: dataContainer,
    });
  }
  clickCollapseUser = (id: any) => {
    const t = $(`#user_${id}`);
    t.next().toggleClass('show');
    t.children()
      .next('.collasible-users-second-item')
      .toggleClass('toggle-rotate');
    $('.collasibleUsers').parent().removeClass('active-item');
    t.parent().addClass('active-item');
  };
  genericUserId(id: any): string {
    return 'user_' + id;
  }
  usersTemplate = (el: any) => {
    return (
      <div key={Math.random()} className='containerCollapseUsers'>
        <div
          id={this.genericUserId(el.id)}
          className='collasibleUsers'
          onClick={() => this.clickCollapseUser(el.id)}
        >
          <div className='collapsible-users-first-item'>
            <div
              style={{ backgroundColor: el.color }}
              className='status-span'
            ></div>
            <div style={{ marginTop: '6px' }}>
              <label className='text-color'>{el.text}</label>
            </div>
          </div>
          <div className='collasible-users-second-item'>
            <FiChevronDown size={20} />
          </div>
        </div>
        <div className='collasibleUsersContent'>
          <div className='collasibleUserSubContent'>
            <div className='contact-user'>
              <div>
                <label className='text-sub-color '>Contact Number : </label>
                <label className=' explain-label'>{el.contactNumber}</label>
              </div>
              <div>
                <label className='text-sub-color '>Email : </label>
                <label className=' explain-label'>{el.email}</label>
              </div>
            </div>
            <div className='action-content-user'>
              <div>
                <label className='text-sub-color'>Status : </label>
                <button
                  // onClick={() => this.clickActionUsersStatus(el.id)}
                  disabled={true}
                  style={{ backgroundColor: el.color }}
                  className='status-action'
                >
                  {el.usersActiveText}
                </button>
              </div>
              <div className='action-content-sub-user'>
                <div>
                  <label className='text-sub-color'>Roles : </label>
                </div>
                <div>
                  <button
                    id='adminUser'
                    className='status-action'
                    disabled={true}
                    //  onClick={() => this.clickActionUserAdmin(el.id)}
                  >
                    {el.isAdmin ? (
                      <div>
                        <label
                          style={{ color: '#000' }}
                          className='text-sub-color'
                        >
                          ADMIN
                        </label>
                        <BsCheck2All size={18} color='white' />
                      </div>
                    ) : (
                      <label
                        style={{ color: '#000' }}
                        className='text-sub-color'
                      >
                        ADMIN
                      </label>
                    )}
                  </button>
                  <button
                    id='approverUser'
                    className='status-action'
                    disabled={true}
                    // onClick={() => this.clickActionUserApprover(el.id)}
                  >
                    {el.isApprover ? (
                      <div>
                        <label
                          style={{ color: 'white' }}
                          className='text-sub-color'
                        >
                          APPROVER
                        </label>
                        <BsCheck2All size={18} color='white' />
                      </div>
                    ) : (
                      <label
                        style={{ color: 'white' }}
                        className='text-sub-color'
                      >
                        APPROVER
                      </label>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  private onSuccessStatus() {
    let data = this.state.ContainerAllData;
    this.current_filter = 'S';
    if (this.gridCompanyTasktracker.getSelectedRecords().length !== 0) {
      const Adaptor_Id =
        this.gridCompanyTasktracker.getSelectedRecords()[0].Adaptor_Id;
      data = this.state.ContainerAllData.filter(
        (item: any) => item.adapter_id === Adaptor_Id
      );
    } else {
      data = this.state.ContainerAllData;
    }
    let successData = data.filter((item: any) => item.status === 0);
    (this.gridContainerTasktracker as GridComponent).dataSource = successData;
    this.setState({ ContainerTempData: successData });
  }
  private onPendingStatus() {
    let data = this.state.ContainerAllData;
    this.current_filter = 'S';
    if (this.gridCompanyTasktracker.getSelectedRecords().length !== 0) {
      const Adaptor_Id =
        this.gridCompanyTasktracker.getSelectedRecords()[0].Adaptor_Id;
      data = this.state.ContainerAllData.filter(
        (item: any) => item.adapter_id === Adaptor_Id
      );
    } else {
      data = this.state.ContainerAllData;
    }
    let successData = data.filter((item: any) => item.status === 3);
    (this.gridContainerTasktracker as GridComponent).dataSource = successData;
    this.setState({ ContainerTempData: successData });
  }
  private onErrortatus() {
    let data = this.state.ContainerAllData;
    this.current_filter = 'E';
    if (this.gridCompanyTasktracker.getSelectedRecords().length !== 0) {
      const Adaptor_Id =
        this.gridCompanyTasktracker.getSelectedRecords()[0].Adaptor_Id;
      data = this.state.ContainerAllData.filter(
        (item: any) => item.adapter_id === Adaptor_Id
      );
    } else {
      data = this.state.ContainerAllData;
    }
    let errorData = data.filter((item: any) => item.status === 1);
    (this.gridContainerTasktracker as GridComponent).dataSource = errorData;
    this.setState({ ContainerTempData: errorData });
  }
  private onCreateConditionTextArea(): void {
    // if (this.showLogMessageClickedItem.container_task_id) {
    //   getContainerTaskOne(
    //     this.showLogMessageClickedItem.container_task_id
    //   ).then((res) => {
    //     let data = res.data;
    //     if (this.textareaObjLog) {
    //       if (this.textareaObjLog.value !== data.log_message) {
    //         this.textareaObjLog.value = data.log_message;
    //       }
    //     }
    //   });
    // }

    var theTextBox = this.textareaObjLog as any;
    var theTextBox = this.textareaObjLog as any;
    if (theTextBox) {
      theTextBox?.addAttributes({ rows: 'auto' });
      theTextBox.respectiveElement.style.height = '520px';
      theTextBox.respectiveElement.style.overflow = 'auto';
      //theTextBox.respectiveElement.style.display = 'flex';
      //theTextBox.respectiveElement.style.minHeight = '500';
    }
    //  this.textareaObjLog.respectiveElement.style.color="red"
  }

  enabledTemplate = (rowData: any) => {
    return rowData.enabled === true ? (
      <div style={{ display: 'flex', borderRadius: "4px", padding: "4px", alignItems: 'center', height:  '100%' }}>
        <FaCheck style={{ color: '#339933', fontSize: '20px' }} title="Enabled" />
      </div>
    ) : (
      <div style={{display: 'flex', borderRadius: "4px", padding: "4px", alignItems: 'center', height:  '100%' }}>
        <FaTimes style={{ color: '#C90016', fontSize: '20px' }} title="Disabled" />
      </div>
    );
  };

  private toolbarTemplateContainer() {
    return (
      <div className='toolbarTemplateTaskTracker'>
        <div className='toolbar-action'>
          {/* <button
            onClick={this.onSuccessStatus.bind(this)}
            className='btn btn-success'
          >
            SUCCESS
          </button>
          <button
            className='btn '
            style={{
              background: 'gray',
            }}
            onClick={this.onPendingStatus.bind(this)}
          >
            PENDING
          </button>
          <button
            onClick={this.onErrortatus.bind(this)}
            className='btn btn-danger'
          >
            ERROR
          </button>
          <button
            onClick={this.onErrortatus.bind(this)}
            className='btn btn-warning'
          >
            RUNNING
          </button> */}
          {/* <BsClouds
            onClick={this.loadAllData.bind(this)}
            color='blue'
            size={25}
          /> */}
          <button
            style={{ backgroundColor: 'transparent', border: 'none', }}
            onClick={this.getContainer.bind(this)}
          >
            <BiRefresh size={25} />
            <span> Refresh</span>
          </button>
        </div>
      </div>
    );
  }
  switchHandler(el: any, args: any) {
    const { last_sync_end_date, last_sync_start_date, max_modified_datetime, ...rest } = el;
    var theObj = {
      ...rest,
      isFull: args.target.properties.checked,
      //last_row_id: 0,
    };
    EditContainerTask(theObj)
      .then((elIn) => {
        Message.success('Success');
        this.HandlerRefreshTask(el, args.syntheticEvent);
      })
      .catch((er) => {
        args.target.checked = false;
        if (er.response) {
          Message.error(
            er.response.data +
              '\n' +
              er.response.status +
              '\n' +
              er.response.headers
          );
        } else if (er.request) {
          Message.error(er.request);
        } else {
          Message.error('Error: ' + er.message);
        }
        Message.error(er.config);
      });
  }

  ExecuteTemp(el: any) {
    let isInitial = false;
    let uniqid = 'button' + el.index;
    const FancyButton = React.forwardRef((props: any, ref) => (
      <button className='FancyButton'>{props.children}</button>
    ));
    return (
      // <div
      //   style={{
      //     display: 'flex',
      //     flexDirection: 'row',
      //   }}
      // >
      //   <button
      //     id={uniqid}
      //     className='execute_button '
      //     onClick={this.HandlerExecuteContainer.bind(this, el, uniqid)}
      //     disabled={!el.isDone}
      //     style={{
      //       marginRight: 5,
      //     }}
      //   >
      //     <FaPlay size={10} color={'#00B900'} />
      //   </button>

      //   <button
      //     id={uniqid}
      //     className='execute_button'
      //     disabled={el.isDone}
      //     style={{
      //       marginRight: 5,
      //     }}
      //     onClick={this.HandlerCancelContainer.bind(this, el, uniqid)}
      //   >
      //     <FaStop size={10} color='#C90016' />
      //   </button>
      //   <button
      //     className='execute_button_task'
      //     style={{
      //       marginRight: 5,
      //     }}
      //     onClick={this.HandlerRefreshContainer.bind(this, el)}
      //   >
      //     <BiRefresh size={20} color={'#00B900'} />
      //   </button>
      // </div>
      <></>
    );
  }
  HandlerRefreshTask(el: any, args: any) {
    this.showLogMessageClickedItem = el;
    var childGridIns = args.target.closest('.e-grid').ej2_instances[0];
    var rowInfo = childGridIns.getRowInfo(args.target.closest('td'));
    var rowIndex = rowInfo.rowIndex;
    if (!args.target.disabled) {
      args.target.disabled = true;
      getContainerTaskOne(el.container_task_id).then((res) => {
        let data = res.data;
        data.last_sync_start_date = this.formatDate(new Date(data.last_sync_start_date));
        data.last_sync_end_date = this.formatDate(new Date(data.last_sync_end_date));
        data.max_modified_datetime = this.formatDate(new Date(data.max_modified_datetime));
        

        childGridIns.updateRow(rowIndex, data);
        if (this.textareaObjLog) {
          if (this.textareaObjLog.value !== data.log_message) {
            this.textareaObjLog.value = data.log_message;
          }
        }
        args.target.disabled = true;
      });
    }
  }

  HandlerExecuteTask(el: any, isSwitch: boolean, args: any) {

    if (this.gridContainerTasktracker) {
    const rows = this.gridContainerTasktracker.getRowsObject();
    this.savedExpandedIds = rows
      .filter((row: any) => row.isExpand && row.data)
      .map((row: any) => row.data.container_id);
    }

    var theObj = {
      isRun: true,
      isDone: false,
      isCancelRequest: false,
      isFull: el.isFull,
      container_task_id: el.container_task_id,
    };
    if(el.target_table == 'temp_job5mfj' || el.target_table == 'temp_jobcacte'
    ||el.target_table == 'Temp_WorkOrder' || el.target_table == 'Temp_WorkOrderOperation') {
      theObj.isFull = true;
    }
    var theInterval: any = '';
    var childGridIns: any;
    if (isSwitch) {
      childGridIns = args.currentTarget?.closest('.e-grid').ej2_instances[0];
    } else {
      childGridIns = args.target?.closest('.e-grid').ej2_instances[0];
    }
    this.currentChildGrid = childGridIns;
    var rowInfo = childGridIns?.getRowInfo(args.target.closest('td'));
    var rowIndex = rowInfo.rowIndex;
    this.current_row_index = rowIndex;
    var the_all = all_information;
    if (!args.target.disabled) {
      args.target.disabled = true;
      EditContainerTask(theObj)
        .then(async (elIn) => {
          this.purgeLogMessage(el.container_task_id);
           await this.getContainersTasks();
           setTimeout(() => {
          if (this.savedExpandedIds && this.savedExpandedIds.length > 0) {
            this.savedExpandedIds.forEach((id) => {
              const index = this.gridContainerTasktracker.getRowIndexByPrimaryKey(id);
              this.safeExpandRow(index);
            });
          }
        }, 100);
          Message.success('Task initiated');
          var theRequestId = await this.createARequest('', 'START OR CANCEL TASK');
          if (theRequestId !== -1) {
            this.watchTask(
              theRequestId,
              theInterval,
              theObj,
              childGridIns,
              rowInfo,
              args.target.disabled
            );
          }
        })
        .catch((er) => {
          if (er.response) {
            Message.error(
              er.response.data +
                '\n' +
                er.response.status +
                '\n' +
                er.response.headers
            );
          } else if (er.request) {
            Message.error(er.request);
          } else {
            Message.error('Error: ' + er.message);
          }
          Message.error(er.config);
        });
    }
  }
  HandlerCancelTask(el: any, args: any) {
    const { last_sync_end_date, last_sync_start_date, max_modified_datetime, ...rest } = el;
    var theObj = {
      ...rest,
      isRun: false,
      status: 3,
      isDone: true,
      isCancelRequest: true,
    };
    var container_task_id = el.container_task_id;
    var childGridIns = args.target.closest('.e-grid').ej2_instances[0];
    var rowInfo = childGridIns.getRowInfo(args.target.closest('td'));
    var rowIndex = rowInfo.rowIndex;
    EditContainerTask(theObj)
      .then(async (el) => {
        Message.success('Task canceled');
        var theRequestId = await this.createARequest('', 'START OR CANCEL TASK');
        getContainerTaskAll(
          { org_id: all_information.company_id },
          undefined
        ).then((res) => {
          let finded: Array<any> = [];
          let data = res.data.filter((elCon: any) => {
          return elCon.container_task_id === container_task_id;
        })[0];

        data.last_sync_start_date = this.formatDate(new Date(data.last_sync_start_date));
        data.last_sync_end_date = this.formatDate(new Date(data.last_sync_end_date));
        data.max_modified_datetime = this.formatDate(new Date(data.max_modified_datetime));

        finded.push(data);
          childGridIns.updateRow(rowIndex, finded[0]);
        });
      })
      .catch((er) => {
        Message.error('Task cancel failed');
        if (er.response) {
          Message.error(
            er.response.data +
              '\n' +
              er.response.status +
              '\n' +
              er.response.headers
          );
        } else if (er.request) {
          Message.error(er.request);
        } else {
          Message.error('Error: ' + er.message);
        }
        Message.error(er.config);
      });
  }
  HandlerRefreshContainer(el: any, args: any) {
    if (!args.currentTarget.disabled) {
      args.currentTarget.disabled = true;
      getContainer(this.source).then((res) => {
        let finded: Array<any> = [];
        finded.push({
          ...res.data.filter((elCon: any) => {
            return elCon.container_id === el.container_id;
          })[0],
        });
        args.target.disabled = false;
        this.gridContainerTasktracker.setRowData(el.container_id, finded[0]);
      });
    }
  }
  HandlerExecuteContainer(el: any, uniqid: string, ref: any) {
    var theInterval: any = '';
    $(`#${uniqid}`).prop('disabled', true);
    var theObj = {
      ...el,
      isRun: true,
      log_message: el.log_message === null ? '' : el.log_message,
      isDone: false,
      isCancelRequest: false,
    };
    EditContainer(theObj)
      .then((elIn) => {
        Message.success('Container initiated');
        var theGrid = this.gridContainerTasktracker;
        theInterval = setInterval(() => {
          getContainer({ org_id: all_information.company_id }).then((res) => {
            let finded: Array<any> = [];
            finded.push({
              ...res.data.filter((elCon: any) => {
                return elCon.container_id === el.container_id;
              })[0],
            });

            theGrid.setRowData(el.container_id, finded[0]);
            if (finded[0].isDone) {
              finded[0].isRun = false;
              EditContainer(finded[0]).then((el) => {
                //(el);
              });
              Message.info('Done! Please check out the container logs');
              clearInterval(theInterval);
            }
          });
        }, 1000);
        Addsource_request({
          request_sql: '',
          request_result: '',
        })
          .then((el) => {
            var data = el.data;
            this.watchContainer(data.request_id, theInterval, theObj);
          })
          .catch((er) => {
            //(er);
          });
      })
      .catch((er) => {
        if (er.response) {
          Message.error(
            er.response.data +
              '\n' +
              er.response.status +
              '\n' +
              er.response.headers
          );
        } else if (er.request) {
          Message.error(er.request);
        } else {
          Message.error('Error: ' + er.message);
        }
        Message.error(er.config);
      });
  }
  HandlerCancelContainer(el: any, uniqid: string) {
    var theObj = {
      ...el,
      isRun: false,
      log_message: el.log_message === null ? '' : el.log_message,
      isDone: true,
      status: 3,
      isCancelRequest: true,
    };
    EditContainer(theObj)
      .then((el) => {
        getContainer(this.source).then((res) => {
          var theGrid = this.gridContainerTasktracker;
          theObj.isRun = false;
          let finded = res.data.filter((elCon: any) => {
            return elCon.container_id === theObj.container_id;
          });
          theGrid.setRowData(theObj.container_id, finded[0]);
          EditContainer(theObj).then((el) => {
            //(el);
          });
          Message.success('The container is canceled');
        });
      })
      .catch((er) => {
        //(er);
        if (er.response) {
          Message.error(
            er.response.data +
              '\n' +
              er.response.status +
              '\n' +
              er.response.headers
          );
        } else if (er.request) {
          Message.error(er.request);
        } else {
          Message.error('Error: ' + er.message);
        }
        Message.error(er.config);
      });
  }
  watchContainer(request_id: any, intervalUp: any, obj: any) {
    var theTimeOut = setTimeout(() => {
      let finded: Array<any> = [];
      finded.push({
        ...this.state.ContainerTempData.filter((el: any) => {
          return obj.container_id === el.container_id;
        })[0],
      });
      Message.error('Windows service out of order');
      clearInterval(interval);
      clearInterval(intervalUp);
      finded[0].isRun = false;
      finded[0].isDone = true;
      finded[0].status = 3;
      finded[0].isCancelRequest = false;
      var theGrid = this.gridContainerTasktracker;
      EditContainer(finded[0]).then((el) => {
        getContainer(this.source).then((res) => {
          let finded2 = res.data.filter((elCon: any) => {
            return elCon.container_id === finded[0].container_id;
          });
          theGrid.setRowData(finded[0].container_id, finded2[0]);
        });
      });

      Deletesource_request({
        request_id: request_id,
      });
    }, 6000);
    var interval = setInterval(() => {
      getsource_request(request_id)
        .then((el) => {
          var getData = el.data[0];

          if (getData.request_result !== '') {
            clearInterval(interval);
            clearTimeout(theTimeOut);
            Message.success('Windows service is up');
            Deletesource_request({
              request_id: request_id,
            });
          }
        })
        .catch((e) => {
          //(e);
        });
    }, 500);
  }
  watchTask(
    request_id: any,
    intervalUp: any,
    obj: any,
    childGridIns: any,
    rowInfo: any,
    buttonDisabled: boolean
  ) {
    var theTimeOut = setTimeout(() => {
      var rowIndex = rowInfo.rowIndex;
      //Message.error('Windows service out of order');
      clearInterval(interval);
      clearInterval(intervalUp);
      obj.isRun = false;
      obj.isDone = true;
      obj.status = 3;
      obj.isCancelRequest = false;
      obj.isRun = false;
      clearInterval(intervalUp);
      buttonDisabled = false;
      // EditContainerTask(obj).then((el) => {
      //   getContainerTaskOne(obj.container_task_id).then((res) => {
      //     // childGridIns.updateRow(rowIndex, res.data);
      //   });
      // });
      this.deleteRequest(request_id);
    }, 10000);
    var interval = setInterval(() => {
      getsource_request(request_id)
        .then((el) => {
          var getData = el.data[0];
          if (getData.request_result !== '') {
            clearInterval(interval);
            clearTimeout(theTimeOut);
            Message.success('Windows service is up');
            Deletesource_request({
              request_id: request_id,
            });
          }
        })
        .catch((e) => {
          //(e);
        });
    }, 500);
  }
  statusTemplate(e: any) {
    let current_content;
    if (e.status === 0) {
      current_content = (
        <div
          style={{
            backgroundColor: '#339933',
            width: '100%',
            height: 25,
            borderRadius: 5,
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            color: 'white',
          }}
        >
          SUCCESS
        </div>
      );
    } else if (e.status === 1) {
      current_content = (
        <div
          style={{
            backgroundColor: '#C90016',
            width: '100%',
            height: 25,
            borderRadius: 5,
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            color: 'white',
          }}
        >
          ERROR
        </div>
      );
    } else if (e.status === 2) {
      current_content = (
        <div
          style={{
            backgroundColor: '#339933',
            width: '100%',
            height: 25,
            borderRadius: 5,
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            color: 'black',
          }}
        >
          RUNNING
        </div>
      );
    } else if (e.status === 3) {
      current_content = (
        <div
          style={{
            backgroundColor: '#fcba03',
            width: '100%',
            height: 25,
            borderRadius: 5,
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            color: 'black',
          }}
        >
          PENDING
        </div>
      );
    }
    // return <div>{current_content}</div>;
    return <></>;
  }
  actionBeginForChild(args: any) {
    if (args.requestType === 'beginEdit') {
      args.cancel = true;
    }
  }
  getContainerData() {
    getContainer({ org_id: all_information.company_id }, this.source).then(
      (el) => {
        let filteredData: Array<any> = [];
        if (this.current_filter === 'S') {
          filteredData = el.data.filter((item: any) => item.status === true);
        } else if (this.current_filter === 'E') {
          filteredData = el.data.filter((item: any) => item.status === false);
        } else {
          filteredData = el.data;
        }
        this.gridContainerTasktracker.dataSource = filteredData;
      }
    );
  }
  detailDataBound = (e: any) => {
    // e.childGrid.dataSource = e.data.children;
    const index = this.gridContainerTasktracker.getRowIndexByPrimaryKey(
      e.data.container_id
    );
    let existing = this.expandedRows.findIndex((el) => el === index);
    if (existing === -1) {
      this.expandedRows.push(index);
    }
  };

  onDataBound = () => {
    if (this.gridContainerTasktracker && this.savedExpandedIds && this.savedExpandedIds.length > 0) {
      setTimeout(() => {
        this.savedExpandedIds.forEach((id) => {
          const index = this.gridContainerTasktracker.getRowIndexByPrimaryKey(id);
          this.safeExpandRow(index);
        });
      }, 100);
    }
  }

  dataBound() {
    if (this.boundFlag) {
      this.boundFlag = false;
      if (this.isFirstLoad) {
        this.isFirstLoad = false;
        const rows = this.gridContainerTasktracker.getRowsObject();
        this.savedExpandedIds = rows
          .filter((row: any) => row.data && !row.data.hasOwnProperty('container_task_id'))
          .map((row: any) => row.data.container_id);
      }
      if (this.savedExpandedIds && this.savedExpandedIds.length > 0) {
        this.savedExpandedIds.forEach((id) => {
          const index = this.gridContainerTasktracker.getRowIndexByPrimaryKey(id);
          if (index !== -1) {
            this.safeExpandRow(index);
          }
        });
      }
    }
  }
  private onLoad = async (args: any) => {
    await this.getContainersTasks();
    // this.gridContainerTasktracker.childGrid.dataSource = this.state?.ChildData;
    // this.gridContainerTasktracker.refresh();
  };
  async createARequest(request: string, message: string): Promise<number> {
    let theRIdentity: number = -1;
    await Addsource_request({
      request_sql: request,
      request_result: message,
      organization_id: all_information.company_id?.toString(),
      app: all_information.app,
    })
      .then((el) => {
        var data = el.data;
        theRIdentity = data.request_id;
      })
      .catch((er) => {
        theRIdentity = -1;
      });
    return theRIdentity;
  }
  deleteRequest(request_id: number) {
    Deletesource_request({
      request_id: request_id,
    });
  }
  // private runTemplate = (args: any) => {
  //   return (
  //     <div>
  //       <button
  //         className='execute_button_task'
  //         onClick={this.HandlerExecuteTask.bind(this, args, false)}
  //         disabled={!args.isDone}
  //         style={{
  //           marginRight: 5,
  //         }}
  //       >
  //         <FaPlay size={10} color={'#00B900'} />
  //       </button>
  //       <button
  //         className='execute_button_task'
  //         disabled={args.isDone}
  //         style={{
  //           marginRight: 5,
  //         }}
  //         onClick={this.HandlerCancelTask.bind(this, args)}
  //       >
  //         <FaStop size={10} color='#C90016' />
  //       </button>
  //       <button
  //         className='execute_button_task'
  //         style={{
  //           marginRight: 5,
  //         }}
  //         onClick={this.HandlerRefreshTask.bind(this, args)}
  //       >
  //         <BiRefresh size={20} color={'#00B900'} />
  //       </button>
  //     </div>
  //   );
  // };
  render() {
    return (
      <div id='task_tracker_dig_element'>
        <div className='tasktracker-sub-content'>
          {/* <div className='container-tasktracker'>
            <CompanyTable
              onRowSelect={this.rowselect.bind(this)}
              isOnlyCompany
            />
          </div> */}

          {/* <div style={{marginTop: "12px", borderRadius: "6px", cursor: "pointer"}}>
            <div
              id='collapse-tasktracker'
              className='collapse-tasktracker-icon'
            >
              <div className='collapse-tasktracker-button'>
                <FiChevronDown id='rotate-icon-tasktracker' size={17} />
              </div>
            </div>
            <div className='container-tasktracker show-taskttracker-content'>
              <div className='flexible-div'>
                <div className='tasktracker-sub'>
                  <div className='header-tasktracker-section'>
                    <div className='header-tasktracker-layout'>
                      <div className='second-tasktracker-text'>
                        <span>Agent Service Status</span>
                      </div>
                      <div>
                        <div className='action-icon-tasktracker'>
                          <div
                            className='add-tasktracker-icon'
                            style={{ display: 'none' }}
                          > */}
                            {/* <IoRemoveSharp size={23} /> */}
                          {/* </div> */}
                          {/* <div
                            className='add-tasktracker-icon'
                            // onClick={this.dialogOpenComponentList.bind(this)}
                          >
                            <MdOutlinePlaylistAdd size={23} />
                          </div> */}
                       {/*  </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className='responsive-layout-tasktracker'
                    style={{ overflow: 'auto' }}
                  > */}
                    {/* <SystemLog /> */}
                  {/* </div>
                </div>
                <div className='tasktracker-sub'>
                  <div className='header-tasktracker-section'>
                    <div className='header-tasktracker-layout'>
                      <div className='second-tasktracker-text'>
                        <span>Administrative & Support Contacts</span>
                      </div>
                      <div>
                        <div className='action-icon-tasktracker'>
                          <div
                            className='add-tasktracker-icon'
                            style={{ display: 'none' }}
                          > */}
                            {/* <IoRemoveSharp size={23} /> */}
                          {/* </div> */}
                          {/* <div
                            className='add-tasktracker-icon'
                            // onClick={this.dialogOpenComponentList.bind(this)}
                          >
                            <MdOutlinePlaylistAdd size={23} />
                          </div> */}
                        {/* </div>
                      </div>
                    </div>
                  </div>
                  <div className='responsive-layout-tasktracker'>
                    {this.state.UsersTempData.length > 0 ? (
                      <div className='border-div'>
                        {this.state.UsersTempData.map((el: any) =>
                          el.isSupport === true ? this.usersTemplate(el) : null
                        )}
                      </div>
                    ) : (
                      'No records to display'
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
 */}
          <div style={{marginTop: "22px"}} className='sync-tasktracker'>
            <span style={{ height: '100px' }}>Synchronization Container</span>
            <GridComponent
              id='dig-task-tracker-sub-one'
              dataSource={this.state.ContainerTempData}
              editSettings={this.editOptions}
              ref={(g: GridComponent) => (this.gridContainerTasktracker = g)}
              height='82vh'
              allowPaging={true}
              pageSettings={this.pageOptions}
              showColumnMenu={true}
              allowResizing={true}
              allowGrouping={false}
              detailDataBound={this.detailDataBound.bind(this)}
              style={{marginTop: "6px"}}
              width='auto'
              enableVirtualMaskRow={false}
              enableHover={false}
              gridLines='Both'
              dataBound={this.onDataBound.bind(this)}
              childGrid={{
                queryString: 'container_id',
                dataSource: this.state.ChildData,
                allowPaging: false,
                queryCellInfo: this.cellRenderContainerTask,
                actionBegin: this.actionBeginForChild,
                created: () => {
                  var childGridsele =
                    this.gridContainerTasktracker.element.querySelectorAll(
                      '.e-grid'
                    ) as any;

                  for (var i = 0; i < childGridsele.length; i++) {
                    this.currentChildGrid = childGridsele[i].ej2_instances[0]; // get the childGrid instances by looping all the childGrid element
                  }
                },
                allowResizing: true,
                editSettings: {
                  allowEditing: true,
                  allowAdding: true,
                  allowDeleting: true,
                },
                enableAltRow: true,
                width: '100%',
                columns: [
                  {
                    field: 'isRun',
                    headerText: 'Execute',
                    textAlign: 'Left',
                    width: '14.8%',
                    // template: this.runTemplate.bind(this),
                  },
                  {
                    field: 'task_id',
                    headerText: 'Task ID',
                    textAlign: 'Left',
                    width: '8%',
                  },
                  {
                    field: 'container_task_id',
                    headerText: 'Container Task ID',
                    textAlign: 'Left',
                    width: '8%',
                    isPrimaryKey: true,
                  },
                  { field: 'task_name', headerText: 'Task Name', width: '16%' },
                  {
                    field: 'last_sync_start_date',
                    headerText: 'Last Sync Start Date',
                    width: '16%',
                  },
                  {
                    field: 'last_sync_end_date',
                    headerText: 'Last Sync End Date',
                    width: '16%',
                  },
                  {
                    field: 'last_sync_duration',
                    headerText: 'Last Sync Duration',
                    width: '8%',
                  },
                  {
                    field: 'last_sync_count',
                    headerText: 'Last Sync Count',
                    width: '8%',
                  },
                  {
                    field: 'log_message',
                    headerText: 'Log Message',
                    width: '16%',
                  },
                  { field: 'status', 
                    headerText: 'Status', 
                    width: '8%' },
                  {
                    field: 'isFull',
                    headerText: 'Incremental/Full',
                    width: '8%',
                  },
                  {
                    field: 'max_modified_datetime',
                    headerText: 'Incremental Date',
                    width: '14.7%',
                  },
                ],
              }}
              allowSelection={false}
              queryCellInfo={this.cellRenderContainer}
              rowSelected={this.rowselect.bind(this)}
              toolbarTemplate={this.toolbarTemplateContainer.bind(this)}
              load={this.onLoad.bind(this)}
              cssClass='task-tracker-grid'
            >
              <ColumnsDirective>
                {/* <ColumnDirective
                  field='isRun'
                  headerText='Execute'
                  textAlign='Left'
                  template={this.ExecuteTemp.bind(this)}
                  width='15%'
                /> */}
                <ColumnDirective
                  field='container_id'
                  headerText='Container ID'
                  textAlign='Left'
                  width='16%'
                  isPrimaryKey
                />
                <ColumnDirective
                  field='container_name'
                  headerText='Container Name'
                  textAlign='Left'
                  width='16%'
                />
                <ColumnDirective
                  field='adapter_name'
                  headerText='Adapter'
                  width='16%'
                  textAlign='Left'
                />
                {/* <ColumnDirective
                  field='alert_mail'
                  headerText='Alert Mail'
                  width='15%'
                  textAlign='Left'
                /> */}
                <ColumnDirective
                  field='last_run'
                  headerText='Last Run'
                  width='16%'
                  textAlign='Left'
                  template={(rowData: any) =>
                    rowData.last_run ? this.dateFormatter(rowData.last_run) : ''
                  }
                />
                <ColumnDirective
                  field='start_date'
                  headerText='Next Run'
                  width='16%'
                  textAlign='Left'
                  template={(rowData: any) =>
                    rowData.start_date
                      ? this.dateFormatter(rowData.start_date)
                      : ''
                  }
                  /*template={(rowData: any) =>
                    rowData.next_run ? this.dateFormatter(rowData.next_run) : ''
                  } */
                />
                <ColumnDirective
                  field='interval'
                  headerText='Interval'
                  width='16%'
                  textAlign='Left'
                />
                <ColumnDirective
                  field='interval_time'
                  headerText='Interval Value'
                  width='16%'
                  textAlign='Left'
                  template={(rowData: any) =>
                    this.formatIntervalValue(rowData.interval, rowData.interval_time)
                  }
                />
                
                {/* <ColumnDirective
                  field='log_message'
                  headerText='Log Message'
                  width='15%'
                  textAlign='Left'
                /> */}
                {/* <ColumnDirective
                  field='enabled_date'
                  headerText='Enabled Date'
                  width='16%'
                  textAlign='Left'
                  template={(rowData: any) =>
                    rowData.enabled_date
                      ? this.dateFormatter(rowData.enabled_date)
                      : ''
                  }
                /> */}
                {/* <ColumnDirective
                  field='start_date'
                  headerText='Start Date'
                  width='16%'
                  textAlign='Left'
                  template={(rowData: any) =>
                    rowData.start_date
                      ? this.dateFormatter(rowData.start_date)
                      : ''
                  }
                /> */}
                {/* <ColumnDirective
                  field='status'
                  headerText='Status'
                  template={this.statusTemplate.bind(this)}
                  width='15%'
                  textAlign='Left'
                /> */}
                <ColumnDirective
                  field='container_rolled_status'
                  headerText='Status'
                  width='16%'
                  textAlign='Left'
                />
                <ColumnDirective
                  field='enabled'
                  headerText='Enabled'
                  template={this.enabledTemplate.bind(this)}
                  width='16%'
                  textAlign='Left'
                />
                
              </ColumnsDirective>
              <Inject
                services={[DetailRow, Toolbar, Filter, Page, Resize, Group]}
              />
            </GridComponent>

            <DialogComponent
              ref={(ref: DialogComponent) => (this.dialogIns = ref)}
              isModal={true}
              id='defaultDialogAddMapping'
              showCloseIcon={true}
              visible={this.state.hideAddDialogLogMessage}
              header='Log Message'
              width={"560px"}
              height={'650px'}
              buttons={this.buttons}
              style={{paddingBottom: "6px", paddingTop: "6px"}}
              //enableResize
              open={() => {
                this.setState({ hideAddDialogLogMessage: true });
              }}
              close={() => {
                this.setState({ hideAddDialogLogMessage: false });
                this.textareaObjLog.value = '';
              }}
              content={() => {
                return (
                  <TextBoxComponent
                    ref={(scope: TextBoxComponent) => {
                      this.textareaObjLog = scope;
                    }}
                    created={this.onCreateConditionTextArea.bind(this)}
                    value={this.state.logMessage}
                    multiline={true}
                    placeholder='Condition'
                    readOnly={true}
                  />
                );
              }}
            />
            <DialogComponent
                id='schedulerDialog'
                header='Set Incremental Date'
                visible={this.state.showSchedulerDialog}
                showCloseIcon={true}
                width='350px'
                isModal={true}
                buttons={this.schedulerButtons}
                close={() => this.setState({ showSchedulerDialog: false })}
                content={() => {
                    return (
                        <DateTimePickerComponent
                            ref={(scope: DateTimePickerComponent) => { this.dateTimePickerInstance = scope; }}
                            format='dd/MM/yyyy HH:mm'
                            floatLabelType='Always'
                        />
                    );
                }}
            />
          </div>
        </div>
      </div>
    );
  }
}
